function providerReducer(state: any, { type, payload }: any) {
  switch (type) {
    case "UPDATE_COORD_LIST":
      return { ...state, coordinatorList: payload };
    case "UPDATE_MEMBER_LIST":
      return { ...state, memberList: payload };
    case "UPDATE_ORGANIZATION_LIST":
      return { ...state, organizationList: payload };
    case "UPDATE_LOGGED_IN_CLIENT":
      return { ...state, loggedInClient: payload };
    default:
      return state;
  }
}

export default providerReducer;
